import {
  AccessTokenDto,
  CreateAuthDto,
  GoogleAuthDto,
  UserDto,
  ValidateTokenDto,
} from "@/common/api/datasources/Api";
import { api } from "@/common/api/instance";

export const authService = {
  login: async (credentials: CreateAuthDto) => {
    const response = await api.auth.authControllerLogin(credentials);
    const { accessToken } = response.data;

    localStorage.setItem("accessToken", accessToken);
    return response.data;
  },

  googleAuth: async (token: string) => {
    const response = await api.auth.authControllerGoogleAuth({
      accessToken: token,
    });

    localStorage.setItem("accessToken", response?.data?.accessToken);
    return response.data;
  },

  validateToken: async (token: string) => {
    const response = await api.auth.authControllerValidateToken({
      token,
    });
    return response.data;
  },

  refreshToken: async () => {
    try {
      const response = await api.auth.authControllerRefresh();
      const { accessToken } = response.data;

      if (accessToken) {
        localStorage.setItem("accessToken", accessToken);
      }

      return response.data;
    } catch (error) {
      localStorage.removeItem("accessToken");
      throw error;
    }
  },

  getProfile: async () => {
    const response = await api.auth.authControllerGetProfile();
    return response.data;
  },

  logout: (queryClient?: any) => {
    localStorage.removeItem("accessToken");
    if (queryClient) {
      queryClient.clear();
    }
  },
};

export const useAuthQuery = () => ({
  loginMutation: {
    mutationFn: (credentials: CreateAuthDto) => authService.login(credentials),
  },

  googleAuthMutation: {
    mutationFn: (accessToken: string) => authService.googleAuth(accessToken),
  },

  validateTokenMutation: {
    mutationFn: (token: string) => authService.validateToken(token),
  },

  refreshTokenMutation: {
    mutationFn: () => authService.refreshToken(),
  },

  profileQuery: {
    queryKey: ["profile"],
    queryFn: () => authService.getProfile(),
  },

  logoutMutation: {
    mutationFn: (queryClient?: any) => {
      authService.logout(queryClient);
    },
  },
});
